import { useContext } from 'react';
import { APIUsageContext } from 'new/components/flows/types/genai_rag/context/APIUsage/APIUsageContext';

export function useAPIUsage() {
  return useContext(APIUsageContext);
}
